import React from 'react'
import { CreateUserToAdmin } from '../components/Users/CreateUserToAdmin';

import '../css/Register.css';

export const CreateUsersSuperAdminPage = () => {
    return <CreateUserToAdmin />
   
}